module.exports = __webpack_public_path__ + "li.494969536a2e7edb219f.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/li.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/li.svg
// module chunks = styles